import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { StyledTooltipWithIcon } from './style';

export interface TooltipWithIconProps {
  title: React.ReactNode;
  placement?:
    | 'top'
    | 'topLeft'
    | 'topRight'
    | 'bottom'
    | 'bottomLeft'
    | 'bottomRight'
    | 'left'
    | 'right';
  className?: string;
}

export const TooltipWithIcon = ({
  title,
  placement = 'bottom',
  className,
}: TooltipWithIconProps) => {
  return (
    <Tooltip title={title} placement={placement}>
      <StyledTooltipWithIcon className={className}>
        <InfoCircleFilled />
      </StyledTooltipWithIcon>
    </Tooltip>
  );
};
